export default class ExtensionOption {
    id: number;
    contractLookupId?: number;
    optionTerm?: number;
    optionUnitTypeId?: number;
    optionAmount?: number;
    optionFeeTypeId?: number;
    optionTotal?: number;
    prepaidOption?: boolean;
    // not mapped
    optionUnitType?: string;
    optionFeeType?: string;
}


// WEBPACK FOOTER //
// ./src/models/ExtensionOption.ts